// extracted by mini-css-extract-plugin
export default {"menu":"ZfrqGBkhoa4C8h87WWGw"};